import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BaseService } from "./base.service";
import { TournamentData } from "app/models";


@Injectable()
export class TournamentService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getCarouselData(): Observable<TournamentData> {
        return this.httpService.get<TournamentData>(this.apiUrl + 'tournaments/carousel/data', null);
    }


}